import warningIcon from "$assets/icons/warning-icon.svg?url";
import { Button } from "$components/button/button";
import { DialogBody } from "$components/dialog/dialog-body";
import { DialogContainer } from "$components/dialog/dialog-container";
import { DialogFooter } from "$components/dialog/dialog-footer";
import { DialogHeader } from "$components/dialog/dialog-header";
import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  makeStyles,
  Typography,
} from "@material-ui/core";
import PrintIcon from "@material-ui/icons/Print";
import { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import type { Payer } from "../InvoiceCard/InsurerAccordion";

const useStyles = makeStyles((theme) => ({
  modal: {
    borderRadius: theme.spacing(3),
  },
  warningMessage: {
    color: theme.palette.grey[600],
    fontWeight: 400,
    marginLeft: theme.spacing(0.5),
  },
  warningIcon: {
    marginRight: theme.spacing(2),
  },
}));

export const PrintPayerSelectionModal: FC<{
  payers: Array<Payer>;
  onClose: () => void;
  onSelection: (payerNames: Array<string>) => void;
}> = ({ payers, onClose, onSelection }) => {
  const classes = useStyles();
  const payerNames = payers.map((p) => ({
    name: p?.insuranceDetails?.name || p.name,
    checked: true,
  }));
  const [selectedPayers, setSelectedPayers] = useState(payerNames);

  const handleCheckboxChange = (event) => {
    const selected = selectedPayers.map((p) =>
      p.name === event.target.name
        ? { name: p.name, checked: event.target.checked }
        : p,
    );
    setSelectedPayers(selected);
  };

  const handleSubmit = useCallback(async () => {
    const selectedPayerNames = selectedPayers
      .filter((i) => i.checked)
      .map((el) => el.name);
    if (selectedPayerNames.length > 0) {
      onSelection(selectedPayerNames);
    }
    onClose();
  }, [selectedPayers, onClose, onSelection]);

  return (
    <DialogContainer open className={classes.modal}>
      <DialogHeader title="">
        <Box display="flex" alignItems="center">
          <img
            src={warningIcon}
            alt="warning"
            className={classes.warningIcon}
          />
          <Typography variant="h5">
            <FormattedMessage
              id="invoices.print.payerselection.title"
              defaultMessage="Select which invoices to print"
            />
          </Typography>
        </Box>
      </DialogHeader>
      <DialogBody>
        {selectedPayers.map((i) => (
          <FormGroup key={i.name}>
            <FormControlLabel
              control={
                <Checkbox
                  name={i.name}
                  value={i.name}
                  color="secondary"
                  checked={i.checked}
                  onChange={handleCheckboxChange}
                />
              }
              label={i.name}
            />
          </FormGroup>
        ))}
      </DialogBody>
      <DialogFooter>
        <Button color="secondary" onClick={() => onClose()}>
          <FormattedMessage
            id="invoices.print.cancel"
            defaultMessage="Cancel"
          />
        </Button>
        <Button
          onClick={handleSubmit}
          color="primary"
          data-testid="invoices.confirmation.accept"
          startIcon={<PrintIcon />}
        >
          <FormattedMessage
            id="invoices.print.accept"
            defaultMessage="Print Selected"
          />
        </Button>
      </DialogFooter>
    </DialogContainer>
  );
};
